/**
 * Csoport-dashboard FE wrapper.
 * BE: GET /groups/:id/dashboard
 *     GET /groups/:id/dashboard/timeseries?range=7d|30d|90d|1y
 */

import type {
  DashboardTimeseries,
  DashboardTimeseriesRange,
  GroupDashboard,
} from '@pta/types';
import { apiCall } from './client';

export function fetchGroupDashboard(groupId: number): Promise<GroupDashboard> {
  return apiCall(`/groups/${groupId}/dashboard`);
}

export function fetchGroupTimeseries(
  groupId: number,
  range: DashboardTimeseriesRange,
): Promise<DashboardTimeseries> {
  return apiCall(`/groups/${groupId}/dashboard/timeseries`, {
    query: { range },
  });
}
